function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { APPLY_AMBASSADOR_SUCCESS, APPLY_AMBASSADOR_IDLE_MODE, APPLY_AMBASSADOR_ERROR } from './send-email.action';
const initialState = {
  idle: true,
  sending: false,
  sent: false
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case APPLY_AMBASSADOR_SUCCESS:
      {
        return _objectSpread({}, state, {
          sent: true,
          idle: false
        });
      }
    case APPLY_AMBASSADOR_IDLE_MODE:
      {
        return _objectSpread({}, state, {
          sent: false,
          idle: true
        });
      }
    case APPLY_AMBASSADOR_ERROR:
      {
        const {
          err
        } = action;
        // eslint-disable-next-line no-console
        console.log('Ambassador sent error: ', err);
        return state;
      }
    default:
      return state;
  }
});